export default function auth({ next, store, to }) {
  // No logueado → login
  if (!store.getters["auth/loggedIn"]) {
    return next({ name: "Login" });
  }

  const rol = store.getters["auth/rolEfectivo"];

  // Home por rol
  const panelPorRol = () => {
    if (rol === 4) return { name: "PanelTipster" };
    if (rol === 5) return { name: "PanelPublicista" };
    if (rol === 3) return { name: "PanelCliente" }; // <- aquí el rol_id real de Cliente
    return { name: "Dashboard" };
  };

  // Si tipster/publicista intenta ir al dashboard general → lo mandamos a su panel
  if ((rol === 4 || rol === 5 || rol === 3) && (to?.name === "Dashboard" || to?.path === "/")) {
    return next(panelPorRol());
  }

  return next();
}
